module.exports = "<div class=\"footer\">\r\n  <a href=\"#\">Sign Out {{userDisplayName}}\r\n    <i class=\"fas fa-sign-out-alt\"></i>\r\n  </a>\r\n</div>"